import { GridFilterApi, GridFilterModel } from '@mui/x-data-grid-pro';
import { getTopicInfo } from '@src/store/reducers/alerts';
import { Alert } from '@src/types/Alerts';
import { SiteMeta } from '@src/types/SiteMeta';
import { Moment } from 'moment';

export const resetFilterModel = {
  items: [
    {
      field: 'severity',
      operator: 'equals',
      value: undefined,
    },
    {
      field: 'unitName',
      operator: 'equals',
      value: '',
    },
    {
      field: 'alertName',
      operator: 'equals',
      value: '',
    },
    {
      field: 'ts',
      operator: 'onOrAfter',
      value: null,
    },
    {
      field: 'ts',
      operator: 'onOrBefore',
      value: null,
    },
  ],
} as GridFilterModel;

export const extractUnitName = (row: Alert, siteMeta: SiteMeta) => {
  const { Use_New_Topic_Structure: useNewTopicStructure } = siteMeta.ui;
  const { dataSource } = getTopicInfo(useNewTopicStructure, row.topic);
  const index = siteMeta.Units.indexOf(dataSource);
  return index === -1 ? 'Site' : siteMeta.UnitNames[index] || 'N/A';
};

export const handleSeverityOptionChange = (
  severity: string,
  filterModel: GridFilterModel,
  upsertFilterItems: GridFilterApi['upsertFilterItems'],
) => {
  const newItems = filterModel.items;
  const severityItem = newItems.findIndex((item) => item.field === 'severity');
  if (severityItem !== -1) {
    newItems[severityItem].value = severity === 'ALL' ? undefined : severity;
  } else {
    newItems.push({
      field: 'severity',
      operator: 'equals',
      value: severity === 'ALL' ? undefined : severity,
    });
  }
  return upsertFilterItems(newItems);
};

export const handleDeviceOptionChange = (
  deviceName: string,
  filterModel: GridFilterModel,
  upsertFilterItems: GridFilterApi['upsertFilterItems'],
) => {
  const newItems = filterModel.items;
  const deviceNameItem = newItems.findIndex(
    (item) => item.field === 'unitName',
  );
  if (deviceNameItem !== -1) {
    newItems[deviceNameItem].value = deviceName;
  } else {
    newItems.push({
      field: 'unitName',
      operator: 'equals',
      value: deviceName,
    });
  }
  return upsertFilterItems(newItems);
};

export const handleAlarmNameOptionChange = (
  alarmName: string,
  filterModel: GridFilterModel,
  upsertFilterItems: GridFilterApi['upsertFilterItems'],
) => {
  const newItems = filterModel.items;
  const alarmNameItem = newItems.findIndex(
    (item) => item.field === 'alertName',
  );
  if (alarmNameItem !== -1) {
    newItems[alarmNameItem].value = alarmName;
  } else {
    newItems.push({
      field: 'alertName',
      operator: 'equals',
      value: alarmName,
    });
  }
  return upsertFilterItems(newItems);
};

export const handleDateTimeChange = (
  date: Moment | null,
  operator: 'onOrAfter' | 'onOrBefore',
  filterModel: GridFilterModel,
  upsertFilterItems: GridFilterApi['upsertFilterItems'],
) => {
  const newItems = filterModel.items;
  const dateItem = newItems.findIndex((item) => item.operator === operator);
  if (dateItem !== -1) {
    newItems[dateItem].value = date;
  } else {
    newItems.push({
      field: 'ts',
      operator,
      value: date,
    });
  }
  return upsertFilterItems(newItems);
};
